module.exports = __webpack_public_path__ + "img/GreenPoint.2cf01d9e.svg";